import { Injectable } from '@angular/core';
import { Logger } from '@app/core';
import { InMemoryDbService, RequestInfo } from 'angular-in-memory-web-api';
import { Observable } from 'rxjs';
import { FakeTenantsService } from './tenants/tenants.service.fake';

const log = new Logger('mock');

/**
 * In-memory backend for faking Ajax calls. This class is a dispatcher that forwards
 * requests to a more specific implementation of InMemoryDbService:
 *
 * /v1/tenants/* -> FakeTenantsService
 */
@Injectable({
  providedIn: 'root'
})
export class InMemoryBackend implements InMemoryDbService {
  private tenants: InMemoryDbService = new FakeTenantsService();

  private collectionToService: Map<string, InMemoryDbService> = new Map([
    ['tenants', this.tenants],
  ]);

  createDb() {
    // We'll supply custom interceptors rather than return a db here
    return {};
  }

  get(ri: RequestInfo, db: {}): Observable<any> {
    return this.dispatch('get', ri, db);
  }

  post(ri: RequestInfo, db: {}): Observable<any> {
    return this.dispatch('post', ri, db);
  }

  private dispatch(method: Method, ri: RequestInfo, db: {}): Observable<any> {
    const handler = this.collectionToService.get(ri.collectionName);
    if (!handler) {
      throw new Error(`Unknown collection: ${ri.url}`);
    }
    const fn: (() => Observable<any>) = handler[method];
    if (!fn) {
      throw new Error(`Method ${method} not implemented in ${ri.collectionName}`);
    }
    return fn.call(handler, ri, db);
  }
}

type Method = 'get' | 'post' | 'put' | 'delete' | 'patch';
